module.exports = __webpack_public_path__ + "assets/img/bajheera.dbf009f2.png";